const option = [
    { id: 'benzin', name: 'เบนซิน' },
    { id: 'diesel', name: 'ดีเซล' }
]

export default {
    option: option
};